<template>
  <div class="address">
    <h2>企业通讯录</h2>
    <div class="container">
      <VueScroll>
        <Collection />
        <hr class="septal-line">
        <GroupItem
          class="group-item"
          :key="group['Department.DisplayName']"
          v-for="group in groupData"
          :group="group"
          :open="false"
          :depth="1"
        />
      </VueScroll>
    </div>
  </div>
</template>

<script>
import GroupItem from './GroupItem.vue';
import Collection from './Collection.vue';
import { getAddressBooks } from '@/api/addressbook';

export default {
  created() {
    getAddressBooks().then((data) => {
      this.groupData = data;
    });
  },
  data() {
    return {
      groupData: null,
    };
  },
  components: { GroupItem, Collection },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.address {
  height: 100%;
  background-color: $light-box-bg;
  box-shadow: 0 0 10px 0 rgba(30, 60, 150, 0.06);
  h2 {
    padding-top: 40px;
    padding-bottom: 21px;
    font-size: 22px;
    line-height: 22px;
    color: $blue;
  }
  .container {
    height: calc(100% - 83px);
    .septal-line{
      margin: 10px 24px;
      border: none;
      border-bottom: 1px solid #e6f2fb;
    }
    .group-item {
      margin: 0 10px 0 10px;
    }
  }
}
</style>
